module.exports = __webpack_public_path__ + "static/media/Patience.84518dd7.png";